<template>
    <div>
        <HeaderMenu></HeaderMenu>
        <HomeSlider/>
        <NMTCCourses />
        <div class="digital_health_section">
            <div class="digital_head_solution">
                <h3>Digital Healthcare Solutions</h3>
            </div>
        </div>
        <div class="radar_video_sec home-page-section">
            <div class="container">
                <div class="row">
                <div class="our_mission_list homepage">
                    <div class="container">
                        <div class="row justify-content-center">
                            <div class="col-xl-12 col-lg-12 col-md-9">
                                <ul class="mission_steps_list">
                                    <li>
                                        <div class="list_block">
                                            <p>Health Quality and Compliance Software</p>
                                        </div>
                                        <div class="row">
                                          <div class="circle_image_wrap">
                                              <router-link v-bind:to="'/digital-health-solutions/#radar-section'"><img src="../../assets/images/radar-img.png"></router-link>
                                          </div>
                                          <div class="radar_video_block video-section">
                                          	<!-- <a href="#" data-toggle="modal" data-target="#exampleModal">
                                              <img src="../../assets/images/video-bg.png">
                                              <div class="video_play_icon" >

                                                  <img src="../../assets/images/video-icon.png">

                                              </div>
                                              </a> -->
                                              <video  id="radar_video_block_tag" controls preload="metadata" poster="../../assets/images/Radar_Video_AdobeCreativeCloudExpress.mp4?thumbnail=1280" muted >
                                                <source src="../../assets/images/Radar_Video_AdobeCreativeCloudExpress.mp4" type="video/mp4">
                                                Your browser does not support the video tag.
                                            </video>
                                          </div>
                                        </div>
                                    </li>
                                    <li>
                                        <div class="list_block">
                                            <p>Hospital Information System</p>
                                        </div>
                                        <div class="row">
                                          <div class="circle_image_wrap">
                                              <router-link v-bind:to="'/digital-health-solutions/#about_main_image_block'"><img src="../../assets/images/image1.png"></router-link>
                                          </div>
                                          <RadarSlider/>
                                        </div>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
                </div>
            </div>
        </div>
        <div class="consultancy-services">
            <div class="services_head_wrap">
                <h3>Consultancy Services</h3>
            </div>
        </div>
        <div class="healthcare_custom_content">
            <div class="container">
                <p>The Healthcare industry is burdened with rapidly evolving market needs and regulatory forces along with cultural shifts and patient-centered systems. Nama understands each player and has the pledge to leverage your capabilities and drive value for your today’s business. We offer a set of dedicated consultancy services that could benefit healthcare providers, health insurance, and governing authorities. Our services include the following:</p>
                <div class="read_more_wrap">
                    <router-link v-bind:to="'/consultancy-services/'" class="read_more">Read More</router-link>
                </div>
            </div>
        </div>
        <div class="homepage modal fade" id="exampleModal">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-body">
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                        <div class="modal-video">
                            <video controls preload="metadata" poster="https://testuc222.sirv.com/Images/NAMA/Radar_Video_AdobeCreativeCloudExpress.mp4?thumbnail=1280">
    						    <source src="https://testuc222.sirv.com/Images/NAMA/Radar_Video_AdobeCreativeCloudExpress.mp4" type="video/mp4">
    						    Your browser does not support the video tag.
    						</video>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

</template>
<script>
import HeaderMenu from '../HeaderMenu'
import HomeSlider from './HomeSlider'
import NMTCCourses from './NMTCCourses'
import RadarSlider from './RadarSlider'

export default {
    name: 'Home',
    components:{
        'HeaderMenu'    :HeaderMenu,
        'HomeSlider'    :HomeSlider,
        'NMTCCourses'   :NMTCCourses,
        'RadarSlider'   :RadarSlider
    }
}
</script>
<style scoped>
.our_mission_list.homepage .radar_video_block.video-section{
  width: 200px;
  height: 200px;
}
#radar_video_block_tag {
  width: 200px;
  height: 200px;
}
</style>



// WEBPACK FOOTER //
// src/components/Home/Home.vue